import "core-js/stable";
import Vue from "vue";
import App from "./App";
import router from "./router";
import CoreuiVue from "@coreui/vue";
import { iconsSet as icons } from "./assets/icons/icons.js";
import store from "./store";

import { BootstrapVue, IconsPlugin } from "bootstrap-vue";

import VCalendar from "v-calendar";
// Use v-calendar & v-date-picker components
Vue.use(VCalendar, {
  componentPrefix: "vc",
});

// Vuesax Component Framework
import Vuesax from "vuesax";
import "material-icons/iconfont/material-icons.css"; //Material Icons
import "boxicons/css/boxicons.min.css"; // boxicons Icons
import "vuesax/dist/vuesax.css"; // Vuesax
import "vue-good-table/dist/vue-good-table.css";
import "bootstrap-vue/dist/bootstrap-vue.css";

Vue.use(Vuesax, {
  colors: {
    primary: "#082258",
    success: "#2eb85c",
    danger: "#e55353",
    warning: "#f9b115",
    dark: "#636f83",
  },
});

Vue.config.performance = true;
Vue.use(CoreuiVue);
Vue.prototype.$log = console.log.bind(console);

// Make BootstrapVue available throughout your project
Vue.use(BootstrapVue);
// Optionally install the BootstrapVue icon components plugin
Vue.use(IconsPlugin);

// Validate forms
import * as VeeValidate from "vee-validate";
import vi from "vee-validate/dist/locale/vi";
Vue.use(VeeValidate, {
  locale: "vi",
  fieldsBagName: "fieldBags",
  dictionary: {
    vi: {
      messages: vi.messages,
    },
  },
});

import VueFileAgent from "vue-file-agent";
import "vue-file-agent/dist/vue-file-agent.css";
Vue.use(VueFileAgent);

// register firebase notifications
//import firebaseMessaging from './firebase/firebaseConfig'
//Vue.prototype.$firebase = firebaseMessaging

new Vue({
  el: "#app",
  router,
  store,
  icons,
  template: "<App/>",
  components: {
    App,
  },
});
